"use strict";
/** state: Final **/
/** family: FileUploader **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var icon_types_1 = require("../../types/icon.types");
var Button_1 = require("../Button");
var DropdownButton_1 = require("../DropdownButton");
var Link_1 = require("../Link");
var ProgressBar_1 = require("../ProgressBar");
var Scrollable_1 = require("../Scrollable");
var CLASS_NAME = 'i-file-uploader';
/**
 * Intended to be used with the {{FileUploader#FileUploader}}.
 *
 * This list provides progress information and interaction with an array of files
 * users are uploading.
 */
var FileUploadList = function (_a) {
    var className = _a.className, dropdownLabel = _a.dropdownLabel, fileMenuGenerator = _a.fileMenuGenerator, files = _a.files, id = _a.id, heading = _a.heading, restProps = __rest(_a, ["className", "dropdownLabel", "fileMenuGenerator", "files", "id", "heading"]);
    return (React.createElement("div", __assign({ className: classNames(CLASS_NAME + "__list", className) }, restProps),
        heading && React.createElement("h4", { className: CLASS_NAME + "__list__title" }, heading),
        React.createElement(Scrollable_1.Scrollable, { className: CLASS_NAME + "__list__container" },
            React.createElement("ul", null, files.map(function (file, i) { return (React.createElement("li", { className: CLASS_NAME + "__list__item", key: i },
                React.createElement("span", { className: CLASS_NAME + "__list__item__text" },
                    file.href ? (React.createElement(Link_1.Link, { href: file.href, label: file.name })) : (file.name),
                    fileMenuGenerator && (React.createElement(DropdownButton_1.DropdownButton, { rightAlign: true, mode: Button_1.ButtonMode.Tertiary, iconName: icon_types_1.Icon.VerticalEllipsis, labelHidden: true, label: dropdownLabel, id: id + "-item-" + i + "-menu-btn" }, fileMenuGenerator(file.name)))),
                file.progress && React.createElement(ProgressBar_1.ProgressBar, { now: file.progress }))); })))));
};
exports.FileUploadList = FileUploadList;
//# sourceMappingURL=FileUploadList.js.map